import { Component, OnInit } from '@angular/core';

import { ROUTE_TRANSITION } from 'src/app/app.animation';



import { UntilDestroy } from '@ngneat/until-destroy';
import { Subject } from "rxjs";
import { filter, takeUntil } from "rxjs/operators";
import { Router, NavigationEnd } from "@angular/router";

@UntilDestroy()
@Component({
  selector: 'calsoft-homepage',
  templateUrl: './homepage.component.html',
  styleUrls: ['./homepage.component.scss'],
  animations: [...ROUTE_TRANSITION],
  host: { '[@routeTransition]': '' },
})
export class HomepageComponent implements OnInit {

  url = '';
  sanitizedUrl = '';


  
  filedName: any = [
    { viewValue: 'Category', value: 'category', type: 'select' },
    { viewValue: 'Image', value: 'image', type: 'text' },
    { viewValue: 'Banner', value: 'banner', type: 'select' },
    { viewValue: 'Text With Image', value: 'textWithImage', type: 'text' },
    { viewValue: 'Other Customization', value: 'otherCustomization', type: 'text' },
    { viewValue: 'Maps', value: 'maps', type: 'text' },
    { viewValue: 'Maps With Contact Form', value: 'mapsWithContactForm', type: 'text' },
    { viewValue: 'Contact Form', value: 'contactForm', type: 'text' },
    { viewValue: 'Text', value: 'freeText', type: 'text' },
    { viewValue: 'Brands Carousel', value: 'brandsCarousel', type: 'text' },
    { viewValue: 'Category Carousel', value: 'categoryCarousel', type: 'text' },
    { viewValue: 'Product Scope', value: 'productScope', type: 'select' },
    { viewValue: 'Blog-Data', value: 'blogData', type: 'text' },
    { viewValue: 'Banner Text With Image', value: 'bannertextWithImage', type: 'select' },
    { viewValue: 'Faq', value: 'faq', type: 'select' },
    { viewValue: 'Slide Banner', value: 'slideBanner', type: 'select' },
    { viewValue: 'Scroll Text', value: 'scrollText', type: 'text' },
    { viewValue: '360 Degree Image', value: '360View', type: 'text' },
    { viewValue: 'Tab Layout', value: 'tabLayout', type: 'text' },
    { viewValue: 'Banner With Video', value: 'bannerVideo', type: 'select' },
    { viewValue: 'Video Carousel', value: 'mp4', type: 'select' },
    { viewValue: 'Store Locations', value: 'storeLocations', type: 'select' },
    { viewValue: 'Banner Text With Button', value: 'bannerTextWithButton', type: 'select' },
    { viewValue: 'Customer Reviews', value: 'customerReviews', type: 'select' },
    { viewValue: 'Carousel With Product', value: 'carouselwithProduct', type: 'select' },
    { viewValue: 'Custom Group Layout', value: 'customGroupLayout', type: 'select' },
    { viewValue: 'Category Carousel With Banner ', value: 'categoryCarouselWithBanner', type: 'select' },
    { viewValue: 'Type Form', value: 'typeForm', type: 'select' },
    { viewValue: 'Table', value: 'table', type: 'select' },
    { viewValue: 'Service Layout', value: 'serviceLayout', type: 'select' },
    { viewValue: 'Step Flow', value: 'stepFlowLayout', type: 'select' },
    { viewValue: 'Button', value: 'buttonType', type: 'text' },
    { viewValue: 'Text Image With Form', value: 'textwithform', type: 'text' },
    { viewValue: 'Text With Text', value: 'textWithText', type: 'text' },
    { viewValue: 'Image Container With Text', value: 'imageContainerWithText', type: 'select' },
    { viewValue: 'Service Contact Button', value: 'serviceContactButton', type: 'text' },
    { viewValue: 'Scroll Text Image With Form', value: 'scrolltextwithform', type: 'text' },
    { viewValue: 'Icon Text With BackGround', value: 'iconTextWithBackground', type: 'text' },
    { viewValue: 'Video Banner', value: 'vedioBanner', type: 'text' },
    { viewValue: 'Service Plan', value: 'servicePlan', type: 'text' },
    { viewValue: 'Slider Image With Text', value: 'sliderImageWithText', type: 'text' },
    { viewValue: 'Partners', value: 'partners', type: 'text' },
    { viewValue: 'Partners-Data', value: 'partnerData', type: 'text' },
    { viewValue: 'Step-form', value: 'stepperform', type: 'text' },
    { viewValue: 'Double-Type-form', value: 'DoubleImagescroll', type: 'text' },
    { viewValue: 'DragDrop', value: 'dragdrop', type: 'text' },
    { viewValue: 'Subscription', value: 'subscription', type: 'text' },
   { viewValue: 'Scrollable Image With Form', value: 'scrollableImageForm', type: 'text' },
   { viewValue: 'Text Animation with text', value: 'TextAnimationwithtext', type: 'text' },
   { viewValue: 'Comparison of our CRM', value: 'ComparisonCorrection', type: 'text' },
   { viewValue: 'Footer', value: 'footer', type: 'text' },
   { viewValue: 'Emi Calculator', value: 'emiCalculator', type: 'text' },
   { viewValue: 'Search Bar with BackGround', value: 'SearchWithBackground', type: 'text' },
   { viewValue: 'Typing with Banner', value: 'TypingWithBanner', type: 'text' },
   { viewValue: 'Live Price', value: 'livePrice', type: 'text' },
   { viewValue: 'Text Hover With Image', value: 'TexthoverWithImage', type: 'select' },
   { viewValue: 'Scroll Navigation with Image', value: 'ScrollNavigationwithImage', type: 'text' },
   { viewValue: 'Scroll with Text and Image', value: 'ScrollWithTextAndImage', type: 'text' },
   { viewValue: 'Free Text with Banner', value: 'FreeTextWithBanner', type: 'text' },
   { viewValue: 'Image with Text 2.0', value: 'ImageWithTextTwo', type: 'text' },
   
   { viewValue: 'Scroll with Text and Animated Image', value: 'ScrollWithTextAndAnimatedImage', type: 'text' },
   { viewValue: 'Scroll with Animation Train Review', value: 'ScrollWithAnimatedReviewTwo', type: 'text' },
   { viewValue: 'CRM Comparison Table', value: 'CRMComparisonTable', type: 'text' },
   { viewValue: 'Scroll with Animated Reviews', value: 'ScrollWithAnimatedReview', type: 'text' },
   { viewValue: 'Scroll with Animation Ultimate', value: 'ScrollWithAnimationUltimate', type: 'text' },
   { viewValue: 'Video Background Hero', value: 'appherovideobackground', type: 'text' },
   { viewValue: 'Video Background Container', value: 'appvideobackground', type: 'text' },
  { viewValue: 'Pyramid with Text and Image', value: 'PyramidWithTextAndImage', type: 'text' },
   { viewValue: 'Number Count', value: 'NumberCount', type: 'text' },
   { viewValue: 'Offer Timing', value: 'OfferTiming', type: 'text' },
    { viewValue: 'Order Success', value: 'OrderSuccess', type: 'text' },
   { viewValue: 'Affliate Section Video', value: 'affliatesectionbackground', type: 'text' },

  ];

  filedName1: any = [
    { viewValue: 'Category', value: 'category', type: 'select' },
    { viewValue: 'Image', value: 'image', type: 'text' },
    { viewValue: 'Banner', value: 'banner', type: 'select' },
    { viewValue: 'Maps', value: 'maps', type: 'text' },
    { viewValue: 'Maps With Contact Form', value: 'mapsWithContactForm', type: 'text' },
    { viewValue: 'Contact Form', value: 'contactForm', type: 'text' },
    { viewValue: 'Text', value: 'freeText', type: 'text' },
    { viewValue: 'Brands Carousel', value: 'brandsCarousel', type: 'text' },
    { viewValue: 'Blog-Data', value: 'blogData', type: 'text' },
  ];
 
  constructor(private router: Router) {
      this.url = this.router.url || '';
      this.sanitizedUrl = this.sanitizeUrl(this.url);
      this.router.events.pipe(filter((e: any) => e instanceof NavigationEnd), takeUntil(this._onDestroy)).subscribe(() => {
        this.url = this.router.url || '';
        this.sanitizedUrl = this.sanitizeUrl(this.url);
      });

 
  }

  ngOnInit(): void {
  

  }

    protected _onDestroy = new Subject<void>();

    sanitizeUrl(u: string): string {
    return (u || '').replace(/^\/+/, '').replace(/[?#&=]/g, '-').replace(/[^a-zA-Z0-9_-]+/g, '-').replace(/-+/g, '-').replace(/^[-]+|[-]+$/g, '').toLowerCase();
  }

    ngOnDestroy() {
        this._onDestroy.next();
        this._onDestroy.complete();
    }
}
